export interface Contact {
    id: number;
    user_id: number;
    category: string | null;
    first_name: string | null;
    last_name: string | null;
    title: string | null;
    organization: string | null;
    organization_abbr: string | null;
}

export const InitContact: Contact = {
    id: 0,
    user_id: 0,
    category: null,
    first_name: null,
    last_name: null,
    title: null,
    organization: null,
    organization_abbr: null,
}
